import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '935242265905047';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Initialize the fbq stub (queues calls until fbevents.js loads)
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    // Inject the fbevents.js script robustly (append to head),
    // avoiding the standard snippet's reliance on an existing <script> tag.
    if (!document.getElementById('meta-pixel-script')) {
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      (document.head || document.documentElement).appendChild(script);
    }
    // Init + fire PageView on every visit
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
    // <noscript> fallback pixel
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript');
      noscript.id = 'meta-pixel-noscript';
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />`;
      document.body.appendChild(noscript);
    }
  }, []);
  return null;
}